/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';

export class Facility extends Model {
  id: number;
  name: string;
  active: boolean;
  pivot?: any;
}
